import { DemoLight } from "../../buttons"
import hero from "../../images/trade-hero.svg"

export default function TradeHero() {
  return (
    <>
      <section className="gray">
        <div className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center  py-10 lg:pt-48 lg:pb-20 xl:max-w-6xl xl:mx-auto">
          <article>
            <h1 className="mb-1">
            Let you clients trade smarter with the World's No. 1 Trading Platform
            </h1>
            <p className="lg:text-2xl">
              Welcome to your one-stop trading platform! Check quotes and place
              trades in one place with our web application for individual and
              institutional traders.
            </p>

            <button className="mt-8 mb-10 md:mb-0">
              <DemoLight />
            </button>
          </article>

          <article>
            <img
              src={hero}
              alt="Trade Smarter With the World's No. 1 Trading Platform"
              title="Trade Smarter With the World's No. 1 Trading Platform"
              className="block mx-auto"
            />
          </article>
        </div>
      </section>
    </>
  )
}
